<div [ngClass]="wrapperClass" *ngIf="hasContent()">
  <ng-container *ngIf="useSegmentedRichTables; else legacyMarkdown">
    <ng-container *ngFor="let segment of segments; trackBy: trackSegment">
      <div class="table-scroll-wrapper" *ngIf="enableScrolling && segment.kind === 'markdown' && segment.content.trim().length > 0">
        <div class="m-t-0 p-t-0 markdown-content" [innerHTML]="segment.content | sanitizeMarkdown"></div>
      </div>
      <div *ngIf="!enableScrolling && segment.kind === 'markdown' && segment.content.trim().length > 0" class="m-t-0 m-b-10 markdown-content" [innerHTML]="segment.content | sanitizeMarkdown"></div>
      <ng-container *ngIf="segment.kind === 'table'">
        <div
          *ngIf="segment.title"
          class="m-b-2 markdown-content rich-table-title"
          [innerHTML]="('### ' + segment.title) | sanitizeMarkdown"
        ></div>
        <app-markdown-rich-table
          [tableMarkdown]="segment.tableMarkdown"
          [tableData]="segment.tableData"
          [isStreaming]="isStreaming"
          [enableTableSearch]="enableTableSearch"
          [enableTableColumnFilter]="enableTableColumnFilter"
          [enableTableDownload]="enableTableDownload"
          [isTablePaginationEnabled]="isTablePaginationEnabled"
          (tableDownloaded)="tableDownloaded.emit($event)"
          (tableDownloadFailed)="tableDownloadFailed.emit()"
        ></app-markdown-rich-table>
      </ng-container>
      <ng-container *ngIf="segment.kind === 'fileAttachment'">
        <app-agent-file-attachment-card
          [s3Path]="segment.s3Path"
          [presignedUrl]="segment.presignedUrl ?? ''"
          [fileName]="segment.fileName"
          [displayFileName]="segment.displayFileName"
          [fileType]="segment.fileType"
          [agentId]="agentId"
          [showActions]="showFileAttachmentActions"
          [isStreaming]="isStreaming"
          (previewRequested)="filePreviewRequested.emit($event)"
          (previewFailed)="filePreviewFailed.emit($event)"
          (downloadCompleted)="fileDownloadCompleted.emit($event)"
          (downloadFailed)="fileDownloadFailed.emit($event)"
        ></app-agent-file-attachment-card>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #legacyMarkdown>
    <div class="table-scroll-wrapper" *ngIf="enableScrolling">
      <div class="m-t-0 p-t-0 markdown-content" [innerHTML]="content | sanitizeMarkdown"></div>
    </div>
    <div *ngIf="!enableScrolling" class="m-t-0 m-b-10 markdown-content" [innerHTML]="content | sanitizeMarkdown"></div>
  </ng-template>
</div>
